import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Icon, Layout,} from 'antd';
import {Helmet} from 'react-helmet';
import {normalizeString} from '../../../helpers';

import {AppBar, AppFooter, Sidebar, TopNavigation,} from '../../Page';
import {BackButton} from '../../UI';
import {Aux} from '../../../hoc';

import './LayoutWrapper.css';
import styles from './LayoutWrapper.module.css';

const {Content} = Layout;

class LayoutWrapper extends PureComponent {
    state = {
        collapsed: false,
        user: {
            balance: 0,
            login: '',
            timeZone: ''
        }
    };

    componentDidUpdate(prevProps) {
        if (prevProps.user !== this.props.user) {
            this.setState({
                user: {
                    balance: this.props.user.balance,
                    login: this.props.user.login,
                    timeZone: this.props.user.time_zone,
                }
            });
        }
    }

    componentDidMount() {
        if (window.innerWidth < 1200) {
            this.setState({
                collapsed: true
            });
        }
    }

    toggle = () => {
        this.setState((state) => {
            const collapsed = state.collapsed;

            return {
                collapsed: !collapsed
            };
        });
    };

    copyright = () => {
        return "© 2017-" + new Date().getFullYear() + ". Powered by Wishmaster Inc.";
    }

    render() {
        const {
            children,
            isAuthenticated,
            logout,
            location
        } = this.props;
        const {
            collapsed,
            user
        } = this.state;
        const {
            protocol,
            hostname
        } = window.location;
        const logo = `${protocol}//${hostname}/logo/${hostname}/logo.png`;
        const pathArray = location.pathname.split('/');
        const pageTitle = normalizeString(pathArray[pathArray.length - 1]);

        const sidebar = isAuthenticated ? (
            <Sidebar
                breakpoint="xl"
                collapsed={collapsed}
                toggle={window.innerWidth < 1200 ? this.toggle : null}
                location={location}
                logout={logout}
                width={150}
                src={logo}
                alt=""
            />
        ) : null;
        const topNavigation = isAuthenticated ? <TopNavigation location={location}/> : null;
        const vertAligned = !isAuthenticated ? styles['content-aligned'] : '';
        const trigger = (
            <Icon
                className={styles.trigger}
                type={collapsed ? 'menu-unfold' : 'menu-fold'}
                onClick={this.toggle}
            />
        );

        return (
            <Aux>
                <Helmet>
                    <title>{pageTitle}</title>
                </Helmet>

                <Layout className={styles['layout-wrapper']}>
                    {sidebar}

                    <Layout>
                        <AppBar
                            user={user}
                            isAuthenticated={isAuthenticated}
                            location={location}
                            trigger={trigger}
                        />
                        <Content className={styles.content + ` ${vertAligned}`}>
                            <div className={styles['content-inner']}>
                                {topNavigation}
                                {children}
                            </div>
                        </Content>
                        <AppFooter copyright={this.copyright()}/>
                    </Layout>
                </Layout>
                <BackButton visibilityHeight={200}/>
            </Aux>
        );
    }
}

LayoutWrapper.propTypes = {
    children: PropTypes.element.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    logout: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
};

export default LayoutWrapper;
